import React from "react";
import { SvgIcon } from "@mui/material";

const IconKey = () => {
    return (
        <SvgIcon>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.6201 4.57001H25.1401V12.19H23.6201V4.57001Z" fill="black" />
                <path d="M22.0908 25.91H23.6208V27.43H22.0908V25.91Z" fill="black" />
                <path d="M22.0908 19.81H23.6208V21.33H22.0908V19.81Z" fill="black" />
                <path d="M22.0908 12.19H23.6208V13.71H22.0908V12.19Z" fill="black" />
                <path d="M22.0908 3.04999H23.6208V4.56999H22.0908V3.04999Z" fill="black" />
                <path d="M20.5703 13.71H22.0903V15.24H20.5703V13.71Z" fill="black" />
                <path d="M20.5703 1.51999H22.0903V3.04999H20.5703V1.51999Z" fill="black" />
                <path d="M17.5205 27.43V30.48H19.0505V28.95H22.0905V27.43H17.5205Z" fill="black" />
                <path d="M17.5205 21.33V25.91H22.0905V24.38H19.0505V22.86H22.0905V21.33H17.5205Z" fill="black" />
                <path d="M20.5705 16.76V15.24H17.5205V19.81H22.0905V18.29H19.0505V16.76H20.5705Z" fill="black" />
                <path d="M17.5202 7.61999H19.0502V4.56999H17.5202V6.09999H16.0002V4.56999H17.5202V3.04999H14.4702V4.56999H12.9502V7.61999H14.4702V9.13999H17.5202V7.61999Z" fill="black" />
                <path d="M14.4707 30.48H17.5207V32H14.4707V30.48Z" fill="black" />
                <path d="M14.4707 15.24H11.4307V16.76H12.9507V30.48H14.4707V15.24Z" fill="black" />
                <path d="M11.4307 0H20.5707V1.52H11.4307V0Z" fill="black" />
                <path d="M9.90039 13.71H11.4304V15.24H9.90039V13.71Z" fill="black" />
                <path d="M9.90039 1.51999H11.4304V3.04999H9.90039V1.51999Z" fill="black" />
                <path d="M8.37988 12.19H9.89988V13.71H8.37988V12.19Z" fill="black" />
                <path d="M8.37988 3.04999H9.89988V4.56999H8.37988V3.04999Z" fill="black" />
                <path d="M6.86035 4.57001H8.38035V12.19H6.86035V4.57001Z" fill="black" />
            </svg>
        </SvgIcon>
    )
}
export default IconKey;